/**
* Benefits JS
* -----------------------------------------------------------------------------
*
* All the JS for the Benefits component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'benefits',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const wrapper = $( '.benefits__wrapper' );
      const benefit = gsap.utils.toArray( '.benefits__box' );
      const tl = gsap.timeline();

      ScrollTrigger.create( {
        animation: tl,
        trigger: wrapper,
        start: `top 80%`,
      } );

      benefit.forEach( ( item, index ) => {
        tl.from( item, {opacity: 0, x: -400, duration: 1}, '-=0.5' );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'benefits', COMPONENT );
} )( app );
